<template>
  <mg-dialog
    :show.sync="dialogVisible"
    title="收货地址"
    size="middle"
    class="address-dialog"
    :class="{ 'address-dialog__h5': isH5 }"
    :append-to-body="true"
    @cancel="cancel"
  >
    <div class="address-list">
      <div class="address-item">
        <div class="name-area">
          <span class="name">{{ addressInfo.name }}</span>
          <span class="phone">{{ addressInfo.addr_mobile }}</span>
        </div>
        <div class="address-area">
          <div class="address">
            {{
              addressInfo.province +
              addressInfo.city +
              addressInfo.district +
              addressInfo.address
            }}
          </div>
          <!-- <div class="handle-box">
            <img
              src="../../../assets/images/address/edit_icon.png"
              alt=""
              @click.stop="handleEdit(addressInfo, index)"
            />
            <img
              src="../../../assets/images/address/delete_icon.png"
              alt=""
              @click.stop="handleDelete(addressInfo, index)"
            />
          </div> -->
        </div>
        <!-- <div class="default-tag" v-if="item.is_default">默认地址</div> -->
      </div>
    </div>
    <div class="tips">
      <p>收货地址一经提交不可修改！</p>
      <p>如果需要更改收货信息或产生争议，请联系课程老师。</p>
    </div>
  </mg-dialog>
</template>

<script>
import MgDialog from "@saas/components/src/components/mg-dialog/Index.vue";
import { isH5, isMobile } from "@saas/components/src";

export default {
  props: {},
  data() {
    return {
      dialogVisible: false,
      timer: null,
      addressInfo: {},
      isH5: isH5(),
    };
  },
  watch: {},
  methods: {
    close() {
      this.dialogVisible = false;
    },
    open(data) {
      this.addressInfo = data;
      this.dialogVisible = true;
    },
    cancel() {
      this.$emit("cancel");
    },
  },
  components: {
    MgDialog,
  },
};
</script>

<style scoped lang="scss">
.address-dialog ::v-deep {
  .el-dialog {
    width: 580px;
  }
  .el-dialog__body {
    padding: 0 20px 25px 20px !important;
  }
  .el-form {
    margin-top: 20px;
  }
  .footer {
    text-align: right;
  }
  .el-dialog__header {
    padding-top: 22px !important;
  }
}
.address-dialog__h5 ::v-deep {
  .el-dialog {
    width: 9.3333rem;
    max-height: 80%;
    overflow: auto;
  }
  .el-dialog__body {
    padding: 0 0.2667rem 0.3333rem 0.2667rem !important;
    overflow: auto;
  }
  .el-form {
    margin-top: 0.2667rem;
  }
  .footer {
    text-align: right;
  }
  .el-dialog__header {
    padding-top: 0.2933rem !important;
    .el-dialog__title {
      font-size: 0.48rem;
    }
  }
  .address-list {
    margin-top: 0.1067rem;
    // max-height: 400px;
    // overflow-y: auto;
    .address-item {
      cursor: pointer;
      position: relative;
      min-height: 2.4rem;
      border-radius: 0.32rem;
      border: 1px solid #e5e6e8;
      margin-top: 0.3733rem;
      padding: 0.48rem 0.5333rem 0 0.48rem;
      &:hover {
        // .handle-box {
        //   visibility: visible !important;
        // }
      }
      .name-area {
        .name {
          font-weight: 600;
          font-size: 0.3733rem;
          color: #0d1400;
          line-height: 0.5867rem;
          display: block;
        }
        .phone {
          font-weight: 400;
          font-size: 0.3733rem;
          color: #0d1400;
          line-height: 0.5867rem;
          margin-left: 0;
        }
      }
      .address-area {
        display: flex;
        justify-content: space-between;
        margin-top: 0.2933rem;
        .address {
          font-weight: 400;
          font-size: 0.3733rem;
          color: #0d1400;
          line-height: 0.5867rem;
          padding-bottom: 0.48rem;
        }
        .handle-box {
          position: absolute;
          right: 0.5333rem;
          bottom: 0.4rem;
          display: flex !important;
          visibility: visible;
          img {
            width: 0.64rem;
            height: 0.64rem;
            cursor: pointer;
            &:not(:last-child) {
              margin-right: 0.4rem;
            }
          }
        }
      }
    }
    .address-item__selected {
      border-color: rgb(255, 255, 255, 0);
      &::after {
        content: "";
        z-index: -1;
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        border: 2px solid #00c89d;
        border-radius: 0.2133rem;
      }
    }
  }
  .tips {
    margin-top: 0.6133rem;
    margin-bottom: 0.3467rem;
    font-weight: 400;
    font-size: 0.3733rem;
    color: #747573;
    line-height: 0.5333rem;
  }
}
.address-list {
  margin-top: 4px;
  .address-item {
    position: relative;
    min-height: 90px;
    border-radius: 12px;
    border: 1px solid #e5e6e8;
    margin-top: 14px;
    padding: 18px 20px 0 18px;
    &:hover {
      .handle-box {
        display: flex !important;
      }
    }
    .name-area {
      .name {
        font-weight: 600;
        font-size: 14px;
        color: #0d1400;
        line-height: 22px;
      }
      .phone {
        font-weight: 400;
        font-size: 14px;
        color: #0d1400;
        line-height: 22px;
        margin-left: 21px;
      }
    }
    .address-area {
      display: flex;
      justify-content: space-between;
      margin-top: 11px;
      .address {
        font-weight: 400;
        font-size: 14px;
        color: #0d1400;
        line-height: 22px;
        padding-bottom: 18px;
      }
      .handle-box {
        display: none;
        img {
          width: 24px;
          height: 24px;
          cursor: pointer;
          &:not(:last-child) {
            margin-right: 15px;
          }
        }
      }
    }
  }
  .address-item__selected {
    border-color: rgb(255, 255, 255, 0);
    &::after {
      content: "";
      z-index: -1;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      border: 2px solid #00c89d;
      border-radius: 8px;
    }
  }
}
.tips {
  margin-top: 30px;
  margin-bottom: 38px;
  font-weight: 400;
  font-size: 14px;
  color: #747573;
  line-height: 20px;
}
</style>
